// extracted by mini-css-extract-plugin
export default {"workCtn":"ProjectsMenu_workCtn__6PCFu","titleCtn":"ProjectsMenu_titleCtn__H13ZE","workTitle":"ProjectsMenu_workTitle__vs7Jj","workItemCtn":"ProjectsMenu_workItemCtn__aPadg"};